import React from 'react';
import FacebookAndInstagramManager from '../social/FacebookAndInstagramManager';
import FacebookAndInstagramManagerV2 from '../social/FacebookAndInstagramManagerV2';
import TwitterAuthentication from '../social/TwitterAuthentication';
import connect from '../utils/connect';
import { FB_REFACTOR } from '../constants/config';

const SocialAccounts = ({ client }: { client: any }) => {
    const fbRefactor = client.permissions?.includes(FB_REFACTOR);

    return (
        <React.Fragment>
            <div className="gds-flex gds-flex--align-stretch">
                {fbRefactor && <FacebookAndInstagramManagerV2 />}
                {!fbRefactor && <FacebookAndInstagramManager />}
                <TwitterAuthentication />
            </div>
        </React.Fragment>
    );
};

export default connect(['client'])(SocialAccounts);
